import { Pipe, PipeTransform } from '@angular/core';
import { PromoFundindRange } from '../Model/PromoFundingRange.Model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'promoRangeFilter',
  standalone: false
})
export class PromoFundindRangeFilterPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(promoFundingRanges: PromoFundindRange[], searchTerm: string, field?: string): PromoFundindRange[] {
    if (!promoFundingRanges || !searchTerm?.trim()) {
      return promoFundingRanges;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return promoFundingRanges.filter(item => {
      if (field && item[field]) {
        const value = this.formatValue(item[field], field);
        return value.includes(lowerSearch);
      }

      const searchableFields = [
        'marketCompanyName',
        'label',
        'max',
        'min',
        'UserName',
        'applicationDate'
      ];

      return searchableFields.some(key => {
        const value = this.formatValue(item[key], key);
        return value.includes(lowerSearch);
      });
    });
  }

  private formatValue(value: any, field: string): string {
    if (value == null) return '';
    if (field === 'applicationDate') {
      const formattedDate = this.datePipe.transform(value, 'MMMM dd, yyyy');
      return formattedDate ? formattedDate.toLowerCase() : '';
    }
    return value.toString().toLowerCase();
  }
}
